module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nmodel.meta = model.meta || {}\nconst title = model.meta.title || model.name || model.nameSEO || storage.__(\"error:unknownPageTitle\");\nmodel.meta.title = title;\n// load different bundles according to loaded route\nconst routeConfig \t\t= ((storage.request || {}).route || {}).config || {}\nconst isOffice \t\t\t= routeConfig.isOffice || false\nconst isStatic\t\t\t= routeConfig.isStatic || false\n// TODO: POIAAA\nconst isShippingOrder\t= routeConfig.isShippingOrder || false\nconst isInvoice\t\t\t= routeConfig.isInvoice || false\nconst isOffer\t\t\t= routeConfig.isOffer || false\nconst isCreditNote\t\t= routeConfig.isCreditNote || false\nconst bodyClasses = utils.environment.getBodyClasses(environment)\nif(model.bodyClass)\tbodyClasses.push(model.bodyClass);\nif(isOffice)\t\tbodyClasses.push('isOffice');\nif(isStatic)\t\tbodyClasses.push('isStatic');\n// TODO: i would love to use the strict mode via doctype (<!doctype html>), but only if one finds a solution for the:\n//  \t\t.base_form_fields_autoComplete .optionList margin-bottom: 100% during strict mode problem.\n%><html lang=\"<%= model.lang %>\">\n<head>\n<!-- meta tags -->\n<title><%= title %></title>\n<!--\t\t<meta name=\"HandheldFriendly\" content=\"True\">-->\n<!--\t\t<meta name=\"MobileOptimized\" content=\"360\"/>-->\n<meta name=\"viewport\" content=\"user-scalable=no,initial-scale=1.0, minimum-scale=1.0,maximum-scale=1.0\">\n<% utils.forEach(model.meta, function(metaContent, metaName){ %>\n<meta name=\"<%= metaName %>\" content=\"<%= metaContent %>\" />\n<% }); %>\n<%- include('meta') %>\n<!-- css sources -->\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/vendors~app~appDocument.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/vendors~style.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/style.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<% if(isOffice){ %>\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/app.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<% } else if(isStatic){ /* TODO: POIAAA */ %>\n<!--\t\t\t<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/appRegistration.css?usTS=<%- model.upStartTimestamp || '-' %>\" />-->\n<% } %>\n</head>\n<body class=\"<%- bodyClasses.join(' ') %>\">\n<!-- sections -->\n<div class=\"appContainer\">\n<%- helpers.renderSection('status'); %>\n<%- helpers.renderSection('main'); %>\n<%- helpers.renderSection('login'); %>\n</div>\n<!-- js server sources -->\n<script type=\"application/javascript\" class=\"dynamicJSSources\">\nglobalThis.route \t\t\t\t= \"<%= model.route || '' %>\";\nglobalThis.tree \t\t\t\t= <%- model.tree || 'null' %>;\nglobalThis.globalActionsByScope = <%- model.globalActionsByScope || 'null' %>;\nglobalThis.updateClientStorage \t= <%- model.updateClientStorage || 'null' %>;\nglobalThis.routeParams \t\t\t= <%- model.routeParams || {} %>;\n</script>\n<!-- js sources -->\n<script type=\"text/javascript\" src=\"/webpack/js/vendors~app~appDocument.js?usTS=<%- model.upStartTimestamp || '-' %>\"></script>\n<% if(isOffice){ %>\n<script type=\"text/javascript\" src=\"/webpack/js/appDocumentPDF.js?usTS=<%- model.upStartTimestamp || '-' %>\"></script>\n<script type=\"text/javascript\" src=\"/webpack/js/app.js?usTS=<%- model.upStartTimestamp || '-' %>\"></script>\n<% } else if(isStatic){ /* TODO: POIAAA */ %>\n<!--\t\t\t<script type=\"text/javascript\" src=\"/webpack/js/appRegistration.js?usTS=<%- model.upStartTimestamp || '-' %>\"></script>-->\n<% } %>\n</body>\n</html>"
  , __filename = "components/layouts/master/master.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
model.meta = model.meta || {}
const title = model.meta.title || model.name || model.nameSEO || storage.__("error:unknownPageTitle");
model.meta.title = title;
// load different bundles according to loaded route
const routeConfig 		= ((storage.request || {}).route || {}).config || {}
const isOffice 			= routeConfig.isOffice || false
const isStatic			= routeConfig.isStatic || false
// TODO: POIAAA
const isShippingOrder	= routeConfig.isShippingOrder || false
const isInvoice			= routeConfig.isInvoice || false
const isOffer			= routeConfig.isOffer || false
const isCreditNote		= routeConfig.isCreditNote || false
const bodyClasses = utils.environment.getBodyClasses(environment)
if(model.bodyClass)	bodyClasses.push(model.bodyClass);
if(isOffice)		bodyClasses.push('isOffice');
if(isStatic)		bodyClasses.push('isStatic');
// TODO: i would love to use the strict mode via doctype (<!doctype html>), but only if one finds a solution for the:
//  		.base_form_fields_autoComplete .optionList margin-bottom: 100% during strict mode problem.

    ; __line = 20
    ; __append("<html lang=\"")
    ; __append(escapeFn( model.lang ))
    ; __append("\">\n<head>\n<!-- meta tags -->\n<title>")
    ; __line = 23
    ; __append(escapeFn( title ))
    ; __append("</title>\n<!--		<meta name=\"HandheldFriendly\" content=\"True\">-->\n<!--		<meta name=\"MobileOptimized\" content=\"360\"/>-->\n<meta name=\"viewport\" content=\"user-scalable=no,initial-scale=1.0, minimum-scale=1.0,maximum-scale=1.0\">\n")
    ; __line = 27
    ;  utils.forEach(model.meta, function(metaContent, metaName){ 
    ; __append("\n<meta name=\"")
    ; __line = 28
    ; __append(escapeFn( metaName ))
    ; __append("\" content=\"")
    ; __append(escapeFn( metaContent ))
    ; __append("\" />\n")
    ; __line = 29
    ;  }); 
    ; __append("\n")
    ; __line = 30
    ; __append( include('meta') )
    ; __append("\n<!-- css sources -->\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/vendors~app~appDocument.css?usTS=")
    ; __line = 32
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/vendors~style.css?usTS=")
    ; __line = 33
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/style.css?usTS=")
    ; __line = 34
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n")
    ; __line = 35
    ;  if(isOffice){ 
    ; __append("\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/app.css?usTS=")
    ; __line = 36
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n")
    ; __line = 37
    ;  } else if(isStatic){ /* TODO: POIAAA */ 
    ; __append("\n<!--			<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/appRegistration.css?usTS=")
    ; __line = 38
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />-->\n")
    ; __line = 39
    ;  } 
    ; __append("\n</head>\n<body class=\"")
    ; __line = 41
    ; __append( bodyClasses.join(' ') )
    ; __append("\">\n<!-- sections -->\n<div class=\"appContainer\">\n")
    ; __line = 44
    ; __append( helpers.renderSection('status') )
    ; __append("\n")
    ; __line = 45
    ; __append( helpers.renderSection('main') )
    ; __append("\n")
    ; __line = 46
    ; __append( helpers.renderSection('login') )
    ; __append("\n</div>\n<!-- js server sources -->\n<script type=\"application/javascript\" class=\"dynamicJSSources\">\nglobalThis.route 				= \"")
    ; __line = 50
    ; __append(escapeFn( model.route || '' ))
    ; __append("\";\nglobalThis.tree 				= ")
    ; __line = 51
    ; __append( model.tree || 'null' )
    ; __append(";\nglobalThis.globalActionsByScope = ")
    ; __line = 52
    ; __append( model.globalActionsByScope || 'null' )
    ; __append(";\nglobalThis.updateClientStorage 	= ")
    ; __line = 53
    ; __append( model.updateClientStorage || 'null' )
    ; __append(";\nglobalThis.routeParams 			= ")
    ; __line = 54
    ; __append( model.routeParams || {} )
    ; __append(";\n</script>\n<!-- js sources -->\n<script type=\"text/javascript\" src=\"/webpack/js/vendors~app~appDocument.js?usTS=")
    ; __line = 57
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\"></script>\n")
    ; __line = 58
    ;  if(isOffice){ 
    ; __append("\n<script type=\"text/javascript\" src=\"/webpack/js/appDocumentPDF.js?usTS=")
    ; __line = 59
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\"></script>\n<script type=\"text/javascript\" src=\"/webpack/js/app.js?usTS=")
    ; __line = 60
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\"></script>\n")
    ; __line = 61
    ;  } else if(isStatic){ /* TODO: POIAAA */ 
    ; __append("\n<!--			<script type=\"text/javascript\" src=\"/webpack/js/appRegistration.js?usTS=")
    ; __line = 62
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\"></script>-->\n")
    ; __line = 63
    ;  } 
    ; __append("\n</body>\n</html>")
    ; __line = 65
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/layouts/master/master.ejs

}